import React, { useState } from 'react';

import './PrivacySettings.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';
import BackButton from
  '../BackButton/BackButton.jsx';

const { Edit, CheckBoxCircle, ArrowUp, ArrowDown, Eye, EyeOff } = icons;

export default function PrivacySettings() {
  const modes = [
    'Niemand',
    'Zichtbaar voor ingelogde bezoekers',
    'Zichtbaar voor alle bezoekers'
  ];

  const [settings, updateSetting] = useState([{
    title: 'Persoonlijke gegevens',
    items: [{
      label: 'Profielfoto',
      mode: 'Zichtbaar'
    }, {
      label: 'Gebruikersnaam (alias)',
      mode: 'Zichtbaar'
    }, {
      label: 'Gevolgde kanalen',
      mode: 'Zichtbaar'
    }, {
      label: 'Geplaatste reacties',
      mode: 'Zichtbaar'
    }, {
      label: 'Jouw zwangerschapsweek',
      mode: 'Zichtbaar'
    }]
  }, {
    title: 'Kanaal gegevens',
    items: [{
      label: 'Jouw bio',
      mode: 'Zichtbaar'
    }]
  }, {
    title: 'Social media',
    items: [{
      label: 'Twitter',
      mode: 'Zichtbaar'
    }, {
      label: 'Instagram',
      mode: 'Zichtbaar'
    }, {
      label: 'Facebook',
      mode: 'Zichtbaar'
    }, {
      label: 'Website',
      mode: 'Niet opgegeven'
    }]
  }]);

  const [editState, setEditState] = useState(false);
  const [currentMode, changeMode] = useState(modes[0]);
  const [dropdownMenu, toggleDropdownMenu] = useState(false);

  return (
    <section id="privacySettings">
      <BackButton />

      <div
        id="privacySettings_form"
        className={getString('privacySettings_folded_out', dropdownMenu)}>
        <div>
          <p id="privacySettings_subtitle">
            Profiel zichtbaarheid
          </p>

          {editState ?
            <div
              id="privacySettings_selected_mode"
              onClick={() => toggleDropdownMenu(!dropdownMenu)}>
              <p>{currentMode}</p>

              {dropdownMenu ? <ArrowUp /> : <ArrowDown />}
            </div> :

            <p>{currentMode}</p>
          }
        </div>

        {editState ?
          <span onClick={() => saveSettings()}>
            <CheckBoxCircle />
          </span> :

          <span onClick={() => setEditState(!editState)}>
            <Edit />
          </span>
        }

        {dropdownMenu &&
          <ul onClick={e => setMode(e)}>{modes.map(mode =>
            currentMode !== mode && <li key={mode}>{mode}</li>)}
          </ul>
        }
      </div>

      {editState && [
        'Zichtbaar voor alle bezoekers',
        'Zichtbaar voor ingelogde bezoekers'
      ].includes(currentMode) &&

        <div id="privacySettings_list">{settings.map((section, sectionId) =>
          <div key={sectionId}>
            <h3>{section.title}</h3>

            <ul>{section.items.map((item, idx) =>
              <li key={idx}>
                <div>
                  <p>{item.label}</p>

                  <span className={getString('privacySettings_marked',
                    item.mode === 'Niet opgegeven')}>

                    {item.mode}
                  </span>
                </div>

                {item.mode === 'Zichtbaar' ?
                  <span onClick={() => toggleValue(sectionId, item)}>
                    <Eye />
                  </span> :

                  <span onClick={() => toggleValue(sectionId, item)}>
                    <EyeOff />
                  </span>
                }
              </li>
            )}
            </ul>
          </div>
        )}
        </div>
      }

      <p>Profiel instellingen aanpassen?</p>

      {link(<p id="privacySettings_link">
        Profiel instellingen</p>, '/profile-settings')}
    </section>
  );

  function toggleValue(id, item) {
    const { label, mode } = item;

    if (mode === 'Niet opgegeven') return;

    const modifiedSettings = [...settings];

    const modifiedItem =
      modifiedSettings[id].items.find(item => item.label === label);

    modifiedItem.mode = modifiedItem.mode === 'Afgeschermd' ?
      'Zichtbaar' : 'Afgeschermd';

    updateSetting(modifiedSettings);
  }

  function setMode(e) {
    changeMode(e.target.textContent);

    toggleDropdownMenu(!dropdownMenu);
  }

  function saveSettings() {
    setEditState(!editState);
    toggleDropdownMenu(false);

    // TODO: send GraphQL mutation
  }
}
